import {Component} from 'react'
import { parseISO, isAfter } from 'date-fns'
import Plus from 'react-feather/dist/icons/plus.js'
import Trash from 'react-feather/dist/icons/trash.js'
import {Link} from 'react-router-dom'

import DeleteAllMissionsModal from '../../../../components/Modals/Mission/DeleteAllMissionsModal.jsx'
import DeleteMissionModal from '../../../../components/Modals/Mission/DeleteMissionModal.jsx'
import Loader from '../../../../../shared/components/Loader/Loader.jsx'
import Mission from '../../../../components/Freelance/Component/Missions/Mission.jsx'
import MissionModal from '../../../../components/Modals/Mission/MissionModal.jsx'

import connectModal from '../../../../../shared/components/Modals/connect.js'
import {generate} from '../../../../routes.js'

import {calculateTotalExperience} from '../../../../../shared/services/freelanceService'

import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx"
import CardRow from "../../../../../shared/components/Styled/Card/CardRow.jsx"
import CardCol from "../../../../../shared/components/Styled/Card/CardCol.jsx"

import './Missions.scss'

export class Missions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      experiencesLength: props.freelance?.experiences?.length ?? 0,
      experiences: props.freelance?.experiences?.length ? this.getSortedMissions(props.freelance.experiences) : []
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (
      (this.props.freelance.id !== prevProps.freelance.id)
      || (this.state.experiencesLength !== (this.props.freelance?.experiences?.length ?? 0))
    ) {
      this.setState({experiencesLength: this.props.freelance?.experiences?.length ?? 0})
    }
  }

  getSortedMissions = (experiences) => {
    return experiences
      .sort((a, b) => {
        if (a.current && !b.current) {
          return -1
        }

        if (b.current && !a.current) {
          return 1
        }

        const dateA = parseISO(a.start)
        const dateB = parseISO(b.start)
        if (dateA && dateB) {
          if (isAfter(dateA, dateB)) {
            return -1
          } else {
            return 1
          }
        } else {
          return 0
        }
      })
  }

  createNewMission = () => {
    this.props.openMissionModal({
      freelance: this.props.freelance,
      experiences: this.state.experiences,
      onClose: this.onClose,
      onSubmit: this.props.submit,
    })
  }

  deleteMissions = () => {
    this.props.openDeleteAllMissionsModal({
      freelance: this.props.freelance,
      experiences: this.state.experiences,
      onClose: this.onClose
    })
  }

  save = async () => {
    try {
      this.setState({loading: true})
      await this.props.submit({
        user: this.props.user,
        freelance: this.props.freelance,
      })
    } catch (e) {
      console.warn(e)
    } finally {
      this.setState({loading: false})
      this.props.onFormSuccess()
    }
  }

  onClose = (newExperiences) => {
    const clonedExperiences = newExperiences.map(exp => ({ ...exp }))
    this.props.freelance.experiences = newExperiences
    this.setState({ experiences: this.getSortedMissions(clonedExperiences) })
  }

  render() {
    const {
      isAdmin,
      freelance,
      submit,
    } = this.props

    return (
      <div>
        <FreelancePage className="p-5">

          <h2 className="text-center">Missions</h2>
          <p className="text-center mb-md-5 mb-2">
            Merci de décrire ici vos différentes expériences.<br/>
          </p>
          {!this.state?.experiences?.length
            ? <div className="callout callout-secondary text-center col-md-7 mx-auto">
              <p>
                Afin de finaliser votre profil et être plus attractif auprès des recruteurs
                veuillez saisir vos expériences.
              </p>
              <button type="button" onClick={this.createNewMission} className="btn btn-outline-primary">
                <Plus/> Ajouter une expérience
              </button>
            </div>
            : <div>
              <CardRow className={'missions-header'} align="center">
                <CardCol flex="1">
                  <p className="bold">
                        Expérience : {calculateTotalExperience(this.state.experiences)?.label}
                  </p>
                </CardCol>
                <CardCol flex="unset">
                  <button type="button" onClick={this.createNewMission} className="btn btn-outline-primary">
                    <Plus/> Ajouter une expérience
                  </button>
                  {this.props.isAdmin ?
                    <button type="button" onClick={this.deleteMissions} className="ml-2 btn btn-outline-danger">
                      <Trash/> Supprimer tout
                    </button>
                    : ''
                  }
                </CardCol>
              </CardRow>

              <Mission
                className="callout callout-mission"
                freelance={freelance}
                experiences={this.state.experiences}
                onClose={this.onClose}
                submit={submit}
                canEdit={true}
                isAdmin={isAdmin}
              />
            </div>
          }
          {!this.props.edit &&
          <div className="mt-5 d-flex flex-wrap align-items-center">
            <div className="mr-auto">
              <Link to={generate({name: 'homepage'})} className="gray">
                Je finirai plus tard (ne pas sauvegarder)
              </Link>
            </div>
            {this.state.experiences.length &&
            <button onClick={this.save} type="button" className="btn btn-primary ml-auto">Étape suivante</button>}
          </div>}
        </FreelancePage>
        <Loader visible={this.state.loading}>
          Sauvegarde en cours...
        </Loader>
      </div>
    )
  }
}

export default connectModal({MissionModal, DeleteMissionModal, DeleteAllMissionsModal}, Missions)
